import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const purchasedSupporterPlan = createSlice({
  name: "purchasedSupporterPlan",
  initialState: false,
  reducers: {
    setPurchasedSupporterPlan(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setPurchasedSupporterPlan } = purchasedSupporterPlan.actions;

export default purchasedSupporterPlan;
